import { render, staticRenderFns } from "./HomeIncomeComparison.vue?vue&type=template&id=79129aaa&scoped=true"
import script from "./HomeIncomeComparison.vue?vue&type=script&lang=js"
export * from "./HomeIncomeComparison.vue?vue&type=script&lang=js"
import style0 from "./HomeIncomeComparison.vue?vue&type=style&index=0&id=79129aaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_16d71e7cf8bf5c3e53d15d26d70867ca/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79129aaa",
  null
  
)

export default component.exports